import * as React from "react";
import { forwardRef } from "react";
const SvgArrowPointDownHeavy = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "-8 -8 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "2.5em", height: "2.5em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21 8L12 17L3 8", stroke: "currentColor", strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgArrowPointDownHeavy);
export default ForwardRef;
